import React from "react";
import { Row, Col } from "react-bootstrap";
import "./Projects.css";

function ProjectSection({
  title,
  subtitle,
  award,
  awardType = "purple",
  link,
  description,
  techStack = [],
  image,
  imageAlt,
  reverse = false,
  paperLink,
  citationText,
}) {
  return (
    <div className="glass-card projectCard mb-5 p-4 p-md-5">
      <Row className={`align-items-center g-4 ${reverse ? "flex-row-reverse" : ""}`}>
        {/* Project Image Col */}
        <Col xs={12} lg={6}>
          <a href={link} target="_blank" rel="noreferrer" className="projectImgLink">
            <div className="projectImgWrapper">
              <img loading="lazy" src={image} alt={imageAlt} className="projectImg img-fluid" />
              <div className="imgOverlay">
                <span className="viewProjectBtn">Explore Project &rarr;</span>
              </div>
            </div>
          </a>
        </Col>

        {/* Project Description Col */}
        <Col xs={12} lg={6}>
          <div className="projectTextContent text-start">
            {/* Award Badge */}
            {award && (
              <div className="mb-2">
                <span
                  className={`badge-pill ${awardType === "gold"
                      ? "badge-pill-gold"
                      : awardType === "cyan"
                        ? "badge-pill-cyan"
                        : "badge-pill-purple"
                    }`}
                >
                  {award}
                </span>
              </div>
            )}

            <h3 className="projectTitle">
              <a href={link} target="_blank" rel="noreferrer" className="projectTitleLink">
                {title}
              </a>
            </h3>

            {subtitle && <div className="projectSubtitle mb-3">{subtitle}</div>}

            <p className="projectDescription">
              {description}
              {paperLink && citationText && (
                <>
                  {" "}Presented in{" "}
                  <a href={paperLink} target="_blank" rel="noreferrer" className="IEEElink">
                    <i>{citationText}</i> (IEEE SSCI)
                  </a>
                  .
                </>
              )}
            </p>

            {/* Tech Stack Pills */}
            <div className="projectTechGrid mb-4">
              {techStack.map((tech, idx) => (
                <span key={idx} className="projectTechBadge">
                  {tech}
                </span>
              ))}
            </div>

            {/* Action Links */}
            <div className="projectActions">
              <a href={link} target="_blank" rel="noreferrer" className="btn-primary-custom btn-sm">
                View Project 🔗
              </a>
              {paperLink && (
                <a href={paperLink} target="_blank" rel="noreferrer" className="btn-secondary-custom btn-sm">
                  IEEE Paper 📄
                </a>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ProjectSection;